import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
} from '@angular/core';
import { GenericSearchComponent } from '@webapp/ui';
import { UsersStoreService } from '../../../store/users-store.service';

@Component({
  selector: 'app-search-users',
  standalone: true,
  imports: [GenericSearchComponent],
  templateUrl: './search-users.component.html',
  styleUrls: ['./search-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchUserComponent {
  private readonly store = inject(UsersStoreService);
  loading = model(false);
  searchQuery = this.store.listStore.getSearch() ?? '';
  onSearchChange(query: string) {
    if (query === undefined) {
      return;
    }
    this.store.listStore.setSearch(query);
  }
}
